import { useTranslation } from 'react-i18next';
import { PLATFORM_PERMISSIONS, PERMISSION_ACTIONS } from '@thinknet-gmbh/platform-common';

import { useGetAbsenceReasonsByCompany } from 'src/hooks/absence-reasons/get-absence-reasons-by-company.hook';
import { useCreateAbsenceReasons } from 'src/hooks/absence-reasons/create-absence-reason.hook';
import { CommonBoxExpand } from 'src/pages/settings/components/company-settings/components/common-box-expand';
import { useUpdateAbsenceReasons } from 'src/hooks/absence-reasons/update-absence-reasons.hook';
import { useDeleteAbsenceReasonById } from 'src/hooks/absence-reasons/delete-absence-reason-by-id.hook';
import { usePermissionCheck } from 'src/hooks/permission-check.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { ABSENCE_REASONS_LABELS } from './absence-reasons.constants';

const AbsenceReasons = () => {
  const { t } = useTranslation('settings');
  const currentCompanyId = useGetCurrentCompanyId();

  const createAbsenceReason = useDeleteAbsenceReasonById();
  const createAbsenceReasons = useCreateAbsenceReasons();
  const updateAbsenceReasons = useUpdateAbsenceReasons();
  const { absenceReasons, loading } = useGetAbsenceReasonsByCompany(currentCompanyId);

  const { checkRule } = usePermissionCheck(PLATFORM_PERMISSIONS.companySettings);
  const canEdit = checkRule(PERMISSION_ACTIONS.update);
  const canCreate = checkRule(PERMISSION_ACTIONS.create);
  const canDelete = checkRule(PERMISSION_ACTIONS.delete);

  const onSubmitCreate = (values: any) => {
    createAbsenceReasons({
      variables: {
        payload: [
          {
            ...values,
            companyId: currentCompanyId,
          },
        ],
      },
    });
  };

  const onSubmitEdit = ({ absenceReasons }: any) => {
    const newAbsenceReasons = absenceReasons.filter((doc: any) => !doc._id);

    updateAbsenceReasons({
      variables: { payload: absenceReasons.filter((doc: any) => !!doc._id) },
    });

    if (newAbsenceReasons.length) {
      createAbsenceReasons({
        variables: {
          payload: newAbsenceReasons.map((data: any) => ({
            ...data,
            companyId: currentCompanyId,
          })),
        },
      });
    }
  };

  const onSubmitDelete = (value: any) => {
    createAbsenceReason({ variables: { absenceReasonId: value._id } });
  };

  return (
    <CommonBoxExpand
      data={absenceReasons}
      separator
      formListName={ABSENCE_REASONS_LABELS.formListName}
      boxExpandTitle={t('companySettings.labels.absenceReasons')}
      createButtonTxt={t('companySettings.buttons.addNewAbsence')}
      formItemName={ABSENCE_REASONS_LABELS.name}
      formItemLabel={t('companySettings.labels.absenceReasonName')}
      requiredMessage={t('companySettings.exceptions.requiredAbsenceReason')}
      inputPlaceholder={t('companySettings.labels.dayOff')}
      colorSelectLabel={t('companySettings.labels.reasonColor')}
      colorSelectName={ABSENCE_REASONS_LABELS.color}
      colorSelectPlaceholder={t('companySettings.labels.chooseColor')}
      onSubmitEditForm={onSubmitEdit}
      onSubmitCreateForm={onSubmitCreate}
      onSubmitDelete={onSubmitDelete}
      canCreate={canCreate}
      canEdit={canEdit}
      canDelete={canDelete}
      loading={loading}
    />
  );
};
export default AbsenceReasons;
